import { AUTHORITIES } from '@app/constants/authorities'
import { LOADING } from '@app/constants/redux-state'
import useLocalization from '@app/hooks/useLocalization'
import { IEducationGrade } from '@app/interfaces/education/education-grade'
import EducationGradeForm from '@app/pages/reference-book-page-details/education-grade/components/education-grade-form/education-grade-form'
import { getEducationGrades } from '@app/store/actions/eduction-grade-actions'
import { rolesChecker } from '@app/utils/roles-checker/rolesChecker'
import { setDocumentTitle } from '@app/utils/set-document-title/set-document-title'
import { Card, Table, Tag } from 'antd'
import axios from 'axios'
import { isEmpty } from 'lodash'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { connect, useDispatch } from 'react-redux'

interface props {
  _state: string
  _educationGrades: IEducationGrade[]
}

const ReferenceBookEducationGrade: React.FC<props> = ({
  _educationGrades,
  _state,
}) => {
  const [t] = useTranslation()
  const dispatch = useDispatch()
  const { localizeData } = useLocalization()
  setDocumentTitle(t('educationGrade.title'))

  useEffect(() => {
    const source = axios.CancelToken.source()
    if (isEmpty(_educationGrades))
      dispatch(getEducationGrades({ source }, t('educationGrade.error')))
    return () => {
      source.cancel('Component got unmounted')
    }
  }, [])

  const columns = [
    {
      title: '№',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: t('educationGrade.educationGrade'),
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: t('general.status'),
      dataIndex: 'status',
      key: 'status',

      render: (tags) => (
        <>
          {tags.map((tag) => {
            const color = tag === true ? 'green' : 'volcano'
            const text =
              color === 'green' ? t('general.active') : t('general.inActive')
            return (
              <Tag color={color} key={tag}>
                {text}
              </Tag>
            )
          })}
        </>
      ),
    },
    {
      title: t('general.action'),
      key: 'action',
      render: (text, record) =>
        rolesChecker([
          AUTHORITIES.ADMIN,
          AUTHORITIES.ROLE_SETTING_DICTIONARY_EDIT,
        ]) ? (
          <EducationGradeForm
            edit={true}
            educationGrade={record.educationGrade}
          />
        ) : null,
    },
  ]

  const data = !isEmpty(_educationGrades)
    ? _educationGrades.map((educationGrade) => {
        return {
          key: educationGrade.id,
          id: educationGrade.id,
          name: localizeData(educationGrade?.data)?.name,
          status: [educationGrade.status],
          educationGrade: educationGrade,
        }
      })
    : []

  return (
    <>
      <Card
        extra={
          rolesChecker([
            AUTHORITIES.ADMIN,
            AUTHORITIES.ROLE_SETTING_DICTIONARY_EDIT,
          ]) ? (
            <EducationGradeForm />
          ) : null
        }
        title={t('educationGrade.title')}
      >
        <Table
          pagination={false}
          loading={_state === LOADING}
          dataSource={data}
          columns={columns}
        />
      </Card>
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    _state: state.educationGrade.state,
    _educationGrades: state.educationGrade.educationGrades,
  }
}

export default connect(mapStateToProps)(ReferenceBookEducationGrade)
